import { Group, Select } from '@mantine/core';
import { ReactNode } from 'react';

export type NavbarCompactSelectProps = {
  icon: ReactNode;
  ariaLabel: string;
  placeholder: string;
  data: { value: string; label: string }[];
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  clearable?: boolean;
  searchable?: boolean;
  /** Select control width; defaults to `min(260px, 60vw)`. */
  width?: string | number;
};

export function NavbarCompactSelect({
  icon,
  ariaLabel,
  placeholder,
  data,
  value,
  onChange,
  clearable = false,
  searchable = false,
  width = 'min(260px, 60vw)',
}: NavbarCompactSelectProps) {
  return (
    <Group spacing="xs" noWrap>
      {icon}
      <Select
        aria-label={ariaLabel}
        placeholder={placeholder}
        data={data}
        value={value ?? null}
        onChange={onChange}
        searchable={searchable}
        clearable={clearable}
        size="xs"
        variant="filled"
        radius="md"
        sx={{
          width,
          '.mantine-Select-input': {
            fontWeight: 500,
          },
        }}
        styles={(theme) => ({
          input: {
            backgroundColor:
              theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
            border: 'none',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          dropdown: {
            width: 'max-content',
            maxWidth: 'calc(100vw - 32px)',
          },
          item: {
            whiteSpace: 'normal',
          },
        })}
      />
    </Group>
  );
}
